import EmblaCarousel from "embla-carousel";
document.addEventListener("DOMContentLoaded", () => {
    const lightbox = document.getElementById("emblaLightbox");
    if( !lightbox ) return;

    const lightboxClose = document.getElementById("emblaLightboxClose");
    const lightboxContainer = lightbox.querySelector(".embla__container");
    if( !lightboxContainer ) return;

    const emblaPrevBtn = document.getElementById("emblaPrev");
    const emblaNextBtn = document.getElementById("emblaNext");
    const mainViewport = document.querySelector(".interior-images .carousel-wrapper");

    if( !mainViewport ) return;

    const mainSlides = mainViewport.querySelectorAll(".carousel-slide");
    let lightboxEmbla;

    function buildLightboxSlides() {
        lightboxContainer.innerHTML = "";
        mainSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.remove("embla-slide-link");
            clone.classList.add("embla__slide");
            const img = clone.querySelector("img");
            if( img ) {
                clone.innerHTML = "";
                clone.appendChild(img);
            }
            disableTabOnParents();
            lightboxContainer.appendChild(clone);
        });
    }

    function openLightbox(startIndex) {
        buildLightboxSlides();
        lightbox.style.display = "flex";

        const viewport = lightbox.querySelector(".embla__viewport");
        if( !lightboxEmbla ) {
            lightboxEmbla = EmblaCarousel(viewport, {loop: true, duration: 0});
        }

        lightboxEmbla.scrollTo(startIndex, true);
    }

    function closeLightbox() {
        enableTabOnParents();
        lightbox.style.display = "none";
    }

    function disableTabOnParents() {
        const parents = [
            document.querySelector(".site-content"),
            document.querySelector("header"),
            document.querySelector("footer"),
        ];

        if( !parents ) return;

        parents.forEach((parent) => {
            if( !parent ) return;

            parent
                .querySelectorAll("a, button, input, textarea, select, [tabindex]")
                .forEach((el) => {
                    el.dataset.prevTab = el.tabIndex; // store original tabindex
                    el.tabIndex = -1; // remove from tab order
                });
        });
    }

    function enableTabOnParents() {
        const parents = [
            document.querySelector(".site-content"),
            document.querySelector("header"),
            document.querySelector("footer"),
        ];

        if( !parents ) return;

        parents.forEach((parent) => {
            if( !parent ) return;

            parent.querySelectorAll("[data-prev-tab]").forEach((el) => {
                el.tabIndex = 1;
            });
        });
    }


    // Lightbox arrow buttons
    emblaPrevBtn.addEventListener("click", () => {
        if( lightboxEmbla ) lightboxEmbla.scrollPrev();
    });

    emblaNextBtn.addEventListener("click", () => {
        if( lightboxEmbla ) lightboxEmbla.scrollNext();
    });

    mainSlides.forEach((slide) => {
        slide.addEventListener("click", () => {
            const index = parseInt(slide.dataset.index, 10);
            openLightbox(index);
        });
    });

    lightboxClose.addEventListener("click", closeLightbox);

    lightbox.addEventListener("click", (e) => {
        if( e.target === lightbox ) closeLightbox();
    });

    document.addEventListener("keydown", (e) => {
        if( e.key === "Escape" && lightbox.style.display === "flex" ) {
            closeLightbox();
        }
    });
});
